import { FieldType } from '@wix/wix-data-schema-types'
import { DEVELOPER_MODE, DATA_MODE } from './enums/dimensions'
const { text, reference } = FieldType

export default ({ isDeveloperModeEnabled, fieldType = text }) => {
  const dimensionsForCurrentMode = isDeveloperModeEnabled
    ? DEVELOPER_MODE
    : DATA_MODE

  const dimensionsForFieldType =
    fieldType === reference
      ? dimensionsForCurrentMode.REFERENCE_FIELD
      : dimensionsForCurrentMode.DEFAULT

  return dimensionsForFieldType
}
